import { http, passthrough } from 'msw';
import { setupWorker } from 'msw/browser';

import clientManagement from 'mocks/admin-endpoints/client-management';
import parameterManagement from 'mocks/admin-endpoints/parameter-management';
import hello from 'mocks/client-endpoints/hello';
import login from 'mocks/client-endpoints/login';

const endpoints = [
	hello,
	login,
	clientManagement,
	parameterManagement,
	// ignore all request with extension
	http.get('*.*', () => passthrough()),
];

export const worker = setupWorker(...endpoints);
